import React from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import './Password.scss';
import HrbTranslate from '../../language/HrbTranslate';

const RequirementItem = (props) => {
    let { name, isSatisfied, hasErrors } = props;
    return (
        <div className={classNames("hrb-pw-req-item", { "hrb-pw-req-error-item": Boolean(hasErrors) && !isSatisfied })}>
            <i className={classNames('la', { 'la-check': isSatisfied, 'la-close': !isSatisfied })} />
            <HrbTranslate text={name} />
        </div>
    );
}

RequirementItem.propTypes = {    
    name: PropTypes.string.isRequired,
    isSatisfied: PropTypes.bool,
    hasErrors: PropTypes.bool
};


export default RequirementItem;
